<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-3 border-right cursor-pointer" :class="{ 'font-weight-bold' : this.$route.name === 'register.index' }"
                                @click="changeRegistrationType('regular')"
                            >
                                {{ $t('auth.personal_register') }}
                            </div>
                            <div class="col-12 col-md-6 col-lg-3 border-right cursor-pointer" :class="{ 'font-weight-bold' : this.$route.name === 'register.business' }"
                                @click="changeRegistrationType('business')"
                            >
                                {{ $t('auth.business_register') }}
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <validation-errors :errors="errors" v-if="errors" ref="errors_container" />
                        <form-status :status="status" v-if="status" />

                        <form ref="form" @submit.prevent="handleSubmit">

                            <div class="form-group row">
                                <label for="first_name" class="col-md-4 col-form-label text-md-right">{{ $t('auth.first_name') }}</label>

                                <div class="col-md-6">
                                    <input id="first_name" type="text" class="form-control" name="first_name" value="" required autocomplete="first_name" autofocus v-model="user.firstName">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="last_name" class="col-md-4 col-form-label text-md-right">{{ $t('auth.last_name') }}</label>

                                <div class="col-md-6">
                                    <input id="last_name" type="text" class="form-control" name="last_name" value="" required autocomplete="last_name" v-model="user.lastName">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="phone" class="col-md-4 col-form-label text-md-right">{{ $t('auth.profile.phone') }}</label>

                                <div class="col-md-6">
                                    <input id="phone" type="text" class="form-control" name="phone" value="" required autocomplete="phone" v-model="user.phoneNumber">
                                </div>
                            </div>


                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">{{ $t('auth.email') }}</label>

                                <div class="col-md-6">
                                    <input id="email" type="email" class="form-control" name="email" value="" required autocomplete="email" autofocus v-model="user.email">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="password" class="col-md-4 col-form-label text-md-right">{{ $t('auth.password') }}</label>

                                <div class="col-md-6">
                                    <input id="password" type="password" class="form-control" name="password" required autocomplete="current-password" v-model="user.password">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="password_confirmation" class="col-md-4 col-form-label text-md-right">{{ $t('auth.confirm_password') }}</label>

                                <div class="col-md-6">
                                    <input id="password_confirmation" type="password" class="form-control" name="password_confirmation" required autocomplete="current-password" ref="password_confirmation">
                                </div>
                            </div>

                            <div>
                                <input id="is_business" type="hidden" name="is_business" value="0">
                            </div>

                            <div class="form-group row mb-0">
                                <div class="col-md-8 offset-md-4">
                                    <button type="submit" class="btn btn-primary" :disabled="loading">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                        {{ $t('auth.register') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ValidationErrors from '@components/ValidationErrors';
    import { mapGetters } from 'vuex';
    import backofficeRepository from '@repositories/BackofficeRepository';
    import backofficeMapsRepository from '@repositories/BackofficeMapsRepository';
    import FormStatus from '@components/FormStatus.vue';
    import toastr from 'toastr';

    export default {
        components: {
            FormStatus,
            ValidationErrors,
        },

        data() {
            return {
                errors: [],
                status: null,
                loading: false,
            };
        },

        computed: {
            ...mapGetters({
                user: 'register/getUserData',
            }),
        },

        created() {
            this.$store.dispatch('register/resetUserData');
        },

        methods: {
            changeRegistrationType(registrationType) {
                if (registrationType === 'regular' && this.$route.name !=='register.index') {
                    this.$router.push({ name: 'register.index' });
                } else if(registrationType === 'business' && this.$route.name !== 'register.business') {
                    this.$router.push({ name: 'register.business' });
                }
            },

            async handleSubmit() {
                this.status = null;
                this.errors = [];
                this.loading = true;

                // Validate password confirmation
                if (this.user.password !== this.$refs.password_confirmation.value) {
                    this.errors.push(this.$t('validation.passwords_have_to_be_same'));
                    this.$nextTick(() => {
                        this.$refs.errors_container.$el.scrollIntoView({ behavior: 'smooth' });
                    });
                    this.loading = false;
                    return;
                }

                try {
                    const response = await backofficeRepository.registerClientUser(this.user);
                    if (response.data.registerClientUser.id) {
                        toastr.success(this.$t('auth.register_success'));
                        //reset form data
                        const user_email = this.user.email;
                        this.$store.dispatch('register/resetUserData');
                        this.$refs.password_confirmation.value = '';
                        this.$router.push({ name: 'register.confirm', params: {email: user_email} });
                    } else {
                        this.errors = backofficeMapsRepository.parseAPIErrors(response);
                    }
                } catch (error) {
                    this.errors = backofficeMapsRepository.parseAPIErrors(error);
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>
